import { infotrack } from '../../api/infotrack';
import { IframeWindow } from '.';

export class Infotrack implements infotrack.Api {
  constructor(private iframe: IframeWindow) {}

  orderSearch(request: infotrack.CreateSearchRequest): void {
    this.iframe.postMessage({
      command: 'infotrack.orderSearch',
      args: request,
    });
  }
}
